import { render, staticRenderFns } from "./SelectMaterials.vue?vue&type=template&id=5d0b40cc&scoped=true"
import script from "./SelectMaterials.vue?vue&type=script&lang=js"
export * from "./SelectMaterials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0b40cc",
  null
  
)

export default component.exports